// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Contact } from './contact';
import { Creditor } from './creditor';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditorContact extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  creditorId!: number;
  contactId!: number;
  contactReference?: string;
  ts!: string;
  contact!: Contact;
  creditor!: Creditor;
}

